import ArrowIcon from '@/assets/icons/arrow-down-black.svg';
import useOutsideClick from '@/shared/hooks/useOutSideClick';
import { ISimpleDropdownOption } from '@/shared/types/interfaces';
import { useCallback, useMemo, useState } from 'react';

interface Props {
    label?: string;
    icon?: string;
    className?: string;
    triggerClassName?: string;
    options?: ISimpleDropdownOption[];
}

const NavbarDropdown = ({ label, icon, className = '', triggerClassName = '', options }: Props) => {
    const [isOpen, setIsOpen] = useState(false);

    const ref = useOutsideClick<HTMLDivElement>(() => {
        setIsOpen(false);
    });

    const handleToggle = useCallback(() => {
        setIsOpen(prev => !prev);
    }, []);

    const paperStyles = useMemo(() => {
        const maxHeight = (options?.length || 0) * 60;
        return {
            maxHeight: isOpen ? `${maxHeight}px` : '0',
            transition: 'max-height 0.2s ease-in-out'
        };
    }, [isOpen, options]);

    const handleOnClick = useCallback(
        (onClick?: () => void) => () => {
            onClick?.();
            setIsOpen(false);
        },
        []
    );

    return (
        <div className={`relative ${className}`} ref={ref} data-testid="button-navbar-dropdown-container">
            <button data-testid="button-navbar-dropdown-toggle" className={`flex h-full w-full items-center gap-2 pl-6 pr-12 ${triggerClassName}`} onClick={handleToggle}>
                <img src={icon} alt="" />
                <span className="font-atkinsonHyperlegible text-lg text-primary-900">{label}</span>
                <img src={ArrowIcon} alt="" className={`relative duration-200 ${isOpen ? 'rotate-180' : ''}`} />
            </button>
            <div
                className={`${isOpen ? 'shadow-dashboardNavbarDropdown' : ''} absolute top-[calc(100%_+_24px)] w-full overflow-hidden rounded-lg bg-[#FEFEFE]`}
                style={paperStyles}
                data-testid="button-navbar-dropdown-content"
            >
                <ul className="flex flex-col" data-testid="button-navbar-dropdown-content-wrapper">
                    {options?.map(({ label, icon, onClick }, idx) => (
                        <li
                            key={idx + label + 'drop'}
                            className="trn hover:bg-grey-400 flex w-full cursor-pointer items-center justify-center gap-4 py-4 duration-200"
                            onClick={handleOnClick(onClick)}
                            data-testid={`button-navbar-dropdown-content-item-${idx}`}
                        >
                            <span className="font-atkinsonHyperlegible text-lg">{label}</span>
                            <img src={icon} alt="" />
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default NavbarDropdown;
